import React from 'react';
import { Menu, Tab, Header } from 'semantic-ui-react';
import { MenuConsumer } from '../../../FoodMenu.context';
import { CategoryContainer } from '../category';
import './Navigation.css';

const NavigationTabsCategorySidebar = ({ center }) => {
  return (
    <MenuConsumer>
      {({ schedules }) => {
        const panes = schedules.map(schedule => {
          const { name, _id } = schedule;
          return {
            menuItem: (
              <Menu.Item>
                <Header as="h3" className="fcfm-category-header">
                  {name}
                </Header>
              </Menu.Item>
            ),
            render: () => (
              <Tab.Pane>
                <CategoryContainer scheduleId={_id} />
              </Tab.Pane>
            ),
          };
        });

        return <Tab panes={panes} className={`fcfm-tabs-container ${center ? 'center' : ''}`} />;
      }}
    </MenuConsumer>
  );
};

export default NavigationTabsCategorySidebar;
